import axios from "axios";
import { AuthData } from "../type/Data";

export async function getAuth(username: any, password: any) {

    try {

        const response: any = await axios.post('https://api.ucaasnetwork.com/ns-api/oauth2/token', null, {
            params: {
                grant_type: 'password',
                client_id: '36350.apicaccess',
                client_secret: '32ab0aee3ce42f8996efa5cdc0b8ee65',
                username: username,
                password: password
            }
        });
        // console.log("getAuthResponse", response.data);
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        return '';
    }
}



export async function getDomains(authData: AuthData) {
    const formData = new FormData();
    formData.append('format', 'json');
    formData.append('object', 'domain');
    formData.append('action', 'read');

    const response = await axios.post('https://api.ucaasnetwork.com/ns-api/', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': authData.token_type + ' ' + authData.access_token
        }
    });

    return response.data;
}

export async function getDomainBillable(domain: string, authData: AuthData) {

    const formData = new FormData();
    formData.append('domain', domain);

    const queryString = new URLSearchParams({
        format: "json",
        object: "domain",
        action: "read",
        billing: "yes"
    }).toString();


    const response = await axios.post(`https://api.ucaasnetwork.com/ns-api/?${queryString}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': authData.token_type + ' ' + authData.access_token
        }
    });

    return response.data;
}

export async function getCDRbyDomain(domain: string, start_date: string, end_date: string, authData: AuthData) {

    const formData = new FormData();
    formData.append('domain', domain);
    formData.append('start_date', start_date);
    formData.append('end_date', end_date);
    formData.append('limit', '1000000');

    const queryString = new URLSearchParams({
        format: "json",
        object: "cdr2",
        action: "read",
        // billing: "yes"
    }).toString();


    const response = await axios.post(`https://api.ucaasnetwork.com/ns-api/?${queryString}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': authData.token_type + ' ' + authData.access_token
        }
    });

    return response.data;
}

export async function getQuoteListing() {

    const response = await axios.get('https://tdapi-sandbox.teledynamics.com/api/v1/product/manufacturer/Yealink', {
        // headers: {
        //     'Content-Type': 'application/json',
        //     'Authorization': 'Basic dGRhcGkrVEhBNjM1MC50ZXN0QHRlbGVkeW5hbWljcy5jb206cEh4R21jWEA='
        // }  
    });

    return response.data;
}
